// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/services/orcamentoService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import { paramsDaLista, type ListaFiltros, type PaginadoComResumo, type OrcamentoListaResumo } from './listaFiltros';
import type {
  OrcamentoResumo,
  OrcamentoDetalhe,
  DavDetalhe,
  CriarOrcamentoRequest,
  AtualizarOrcamentoRequest,
} from '../types';

const BASE = '/api/orcamentos';

export const orcamentoService = {
  async getAll(pagina = 1, tamanhoPagina = 20, filtros: ListaFiltros = {}): Promise<PaginadoComResumo<OrcamentoResumo, OrcamentoListaResumo>> {
    const { data } = await apiClient.get<PaginadoComResumo<OrcamentoResumo, OrcamentoListaResumo>>(BASE, {
      params: paramsDaLista(pagina, tamanhoPagina, filtros),
    });
    return data;
  },

  async getAbertos(): Promise<OrcamentoResumo[]> {
    const { data } = await apiClient.get<OrcamentoResumo[]>(`${BASE}/abertos`);
    return data;
  },

  async getPorPeriodo(inicio: string, fim: string): Promise<OrcamentoResumo[]> {
    const { data } = await apiClient.get<OrcamentoResumo[]>(`${BASE}/periodo`, {
      params: { inicio, fim },
    });
    return data;
  },

  async getById(id: number): Promise<OrcamentoDetalhe> {
    const { data } = await apiClient.get<OrcamentoDetalhe>(`${BASE}/${id}`);
    return data;
  },

  async create(request: CriarOrcamentoRequest): Promise<OrcamentoDetalhe> {
    const { data } = await apiClient.post<OrcamentoDetalhe>(BASE, request);
    return data;
  },

  async update(id: number, request: AtualizarOrcamentoRequest): Promise<OrcamentoResumo> {
    const { data } = await apiClient.put<OrcamentoResumo>(`${BASE}/${id}`, request);
    return data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },

  async converterEmDav(id: number): Promise<DavDetalhe> {
    const { data } = await apiClient.post<DavDetalhe>(`${BASE}/${id}/converter-dav`);
    return data;
  },
};
